import React from "react";
import AccommodationSummary from "./AccommodationSummary";
import { formatPriceRangeForEntity, formatPhoneNumber } from "../helpers/formatting";
import './Facility.scss';

const Facility = ({ resultNum, facility }) => {
    return (
        <div className="Facility">
            <span className="resultNum">{resultNum}.</span>
            <span className="details">
                <div className="name">{facility.name}</div>
                <div className="locationAndContact">
                    {facility.address}<br />
                    {facility.city}, {facility.state} {facility.zipcode}<br />
                    Contact: {facility.admin_name}<br />
                    <i className="fa fa-phone"></i> <a href={'tel:' + facility.phone_number}>{formatPhoneNumber(facility.phone_number)}</a><br />
                    <i className="fa fa-envelope"></i> <a href={'mailto:' + facility.email.toLowerCase()}>{facility.email.toLowerCase()}</a>
                </div>
            </span>
            <span className="properties">
                <div>
                    Capacity: <em>{facility.capacity} {facility.capacity !== 1 ? 'beds': 'bed'}</em><br />
                    Monthly Price: <em>{formatPriceRangeForEntity(facility)}{facility.care_charges ? ' (excludes care-related charges)' : ''}</em><br />
                    Dementia Care: <em>{facility.dementia !== 'NONE' ? `Yes${facility.dementia !== 'ALL' ? ' (Mild-only)' : ''}` : 'No'}</em><br />
                    Hospice Waiver: <em>{facility.hospice ? 'Yes' : 'No'}</em><br />
                    Pets Allowed: <em>{facility.pets_allowed ? 'Yes' : 'No'}</em><br />
                    CA CCL Facility ID: <em>{facility.ccl_facility_id}</em> (<a href={facility.ccl_link} target="_blank" rel="noreferrer">View Profile</a>)
                </div>
            </span>
            <span className="accommodations">
                <div>
                    {facility.accommodations.map((accommodation) => <AccommodationSummary accommodation={accommodation} key={accommodation.id} />)}
                </div>
            </span>
        </div>
    )
};

export default Facility;